import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { TeiHubLinkAllStoresModel } from "features/hublink/core/domain/tei-hub-link-group.model";
import {
  GetTeiHubLinkAllStoresResponse,
  GetTeiHubLinkAllStoresRepository,
} from "features/hublink/data/tei-hub-link.repository";

export enum TeiHubLinkAllStores {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: TeiHubLinkAllStores;
  message: string;
  data: Array<TeiHubLinkAllStoresModel> | undefined;
}

const initialState: InitialState = {
  status: TeiHubLinkAllStores.initial,
  message: "",
  data: undefined,
};

export const teiHubLinkAllStores = createAsyncThunk(
  "teiHubLinkAllStores",
  async (param: string, { rejectWithValue }) => {
    try {
      const response: GetTeiHubLinkAllStoresResponse =
        await GetTeiHubLinkAllStoresRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const teiHubLinkAllStoresSlice = createSlice({
  name: "teiHubLinkAllStores",
  initialState,
  reducers: {
    resetTeiHubLinkAllStores: (state) => {
      state.status = TeiHubLinkAllStores.inProgress;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(teiHubLinkAllStores.pending, (state) => {
        state.status = TeiHubLinkAllStores.inProgress;
      })
      .addCase(teiHubLinkAllStores.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = TeiHubLinkAllStores.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(teiHubLinkAllStores.rejected, (state, action) => {
        state.status = TeiHubLinkAllStores.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectTeiHubLinkAllStores = (state: RootState) =>
  state.teiHubLinkAllStores;

export const { resetTeiHubLinkAllStores } = teiHubLinkAllStoresSlice.actions;
export default teiHubLinkAllStoresSlice.reducer;
